export default __webpack_public_path__ + "static/media/people.a591e9b5.svg";